import { Box, Paper, Typography } from '@mui/material'
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid'

interface Column {
  field: string
  title: string
}

interface UserTableProps {
  title: string
  columns: Column[]
  data: Record<string, any>[]
}

const UserTable = ({ title, columns, data }: UserTableProps) => {
  const formattedColumns: GridColDef[] = columns.map(col => ({
    field: col.field,
    headerName: col.title,
    flex: 1
  }))

  return (
    <Paper sx={{ p: 2, height: 500, width: '90%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {title}
      </Typography>

      <Box sx={{ height: '100%' }}>
        <DataGrid
          rows={data.map((row, index) => ({ id: index, ...row }))}
          columns={formattedColumns}
          pageSizeOptions={[5, 10, 25]}
          disableRowSelectionOnClick
          slots={{ toolbar: GridToolbar }}
        />
      </Box>
    </Paper>
  )
}

export default UserTable
